export const TYPES_EXPLANATION = {
  VIDEO: 'video error',
  AUDIO: 'audio error',
  VIDEO_AUDIO: 'video and audio error',
};

export const enum MEDIA_RECORDER_STATES {
  INACTIVE = 'inactive',
  RECORDING = 'recording',
  PAUSED = 'paused',
}

export const ERROR_ENUM = {
  NotAllowedError: 'NotAllowedError',
  NotFoundError: 'NotFoundError',
  NotReadableError: 'NotReadableError',
  AbortError: 'AbortError',
  OverconstrainedError: 'OverconstrainedError',
  SecurityError: 'SecurityError',
  TypeError: 'TypeError',
  NoSoundError: 'NoSoundError',
  UndefinedError: 'UndefinedError',
  VideoCorrupted: 'VideoCorrupted',
};

export const recorderErrors = {
  [ERROR_ENUM.NotAllowedError]: {
    type: TYPES_EXPLANATION.VIDEO_AUDIO,
    message: 'User denies permission, or matching media is not available',
    name: ERROR_ENUM.NotAllowedError,
  },
  [ERROR_ENUM.NotFoundError]: {
    type: TYPES_EXPLANATION.VIDEO_AUDIO,
    message: 'User denies permission, or matching media is not available',
    name: ERROR_ENUM.NotFoundError,
  },
  [ERROR_ENUM.NotReadableError]: {
    type: TYPES_EXPLANATION.VIDEO_AUDIO,
    message: 'Problem occurred which prevented the device from being used.',
    name: ERROR_ENUM.NotReadableError,
  },
  [ERROR_ENUM.AbortError]: {
    type: TYPES_EXPLANATION.VIDEO_AUDIO,
    message: 'Problem occurred which prevented the device from being used.',
    name: ERROR_ENUM.AbortError,
  },
  [ERROR_ENUM.OverconstrainedError]: {
    type: TYPES_EXPLANATION.VIDEO_AUDIO,
    message: 'No camera exists with this resolution or higher. Also it can be an issue with other params',
    name: ERROR_ENUM.OverconstrainedError,
  },
  [ERROR_ENUM.SecurityError]: {
    type: TYPES_EXPLANATION.VIDEO_AUDIO,
    message: 'User denies permission, or matching media is not available',
    name: ERROR_ENUM.SecurityError,
  },
  [ERROR_ENUM.TypeError]: {
    type: TYPES_EXPLANATION.VIDEO_AUDIO,
    message: 'The list of constraints specified is empty',
    name: ERROR_ENUM.TypeError,
  },
  [ERROR_ENUM.NoSoundError]: {
    type: TYPES_EXPLANATION.AUDIO,
    message: 'no sound from your mic',
    name: ERROR_ENUM.NoSoundError,
  },
  [ERROR_ENUM.UndefinedError]: {
    type: TYPES_EXPLANATION.VIDEO_AUDIO,
    message: 'Oops, something unexpected happened.',
    name: ERROR_ENUM.UndefinedError,
  },
  [ERROR_ENUM.VideoCorrupted]: {
    type: TYPES_EXPLANATION.VIDEO_AUDIO,
    message: 'Something went wrong with this video, please try again',
    name: ERROR_ENUM.VideoCorrupted,
  },
} as const;
